var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaginationEnd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 9 8",
    style: {
      enableBackground: "new 0 0 9 8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1,8C0.7,8,0.5,7.9,0.3,7.7c-0.4-0.4-0.4-1,0-1.4L2.6,4L0.3,1.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l3,3 c0.4,0.4,0.4,1,0,1.4l-3,3C1.5,7.9,1.3,8,1,8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5,8C4.7,8,4.5,7.9,4.3,7.7c-0.4-0.4-0.4-1,0-1.4L6.6,4L4.3,1.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l3,3 c0.4,0.4,0.4,1,0,1.4l-3,3C5.5,7.9,5.3,8,5,8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationEnd);
export default __webpack_public_path__ + "static/media/pagination-end.dc865cc71a58a3df540af39b6def1c59.svg";
export { ForwardRef as ReactComponent };